// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c7d4233d","453":"07347a4a","455":"632ba5d8","879":"885010bb","977":"e42bc557"}[chunkId] + ".chunk.js";
};